module.exports = __webpack_public_path__ + "img/125.071878c3.jpg";